import './content.scss';

import { func, node } from 'prop-types';
import React, { useEffect } from 'react';
import { Container } from 'reactstrap';

function Content({ children, fetchMerchants }) {
  useEffect(() => {
    fetchMerchants();
  });

  return (
    <Container className="main" fluid>
      {children}
    </Container>
  );
}

Content.propTypes = {
  children: node,
  fetchMerchants: func.isRequired,
};

Content.defaultProps = {
  children: [],
};

export default Content;
